import { onBeforeUnmount, onMounted } from '@nuxtjs/composition-api';
import debounce from 'lodash.debounce';

const SELECTORS = {
  SUBMIT_BUTTON: '.payment-step__button--submit',
  TERMS_ELEMENT: '.payment-step__terms',
  PAYPAL_BUTTONS: '.paypal-buttons'
};

const CONFIG = {
  RESIZE_DEBOUNCE_DELAY: 200
};

export const usePayPalButtonPosition = (): void => {
  const getElementsInfo = (): {
    buttonMarginBottom: number;
    termsElHeight: number;
  } => {
    const submitButton = document.querySelector(SELECTORS.SUBMIT_BUTTON) as HTMLElement | null;
    const termsEl = document.querySelector(SELECTORS.TERMS_ELEMENT) as HTMLElement | null;

    return {
      buttonMarginBottom: submitButton ? parseFloat(getComputedStyle(submitButton).marginBottom) : 0,
      termsElHeight: termsEl ? termsEl.offsetHeight : 0
    };
  };

  const updatePayPalButtonStyles = (): void => {
    const paypalButton = document.querySelector(SELECTORS.PAYPAL_BUTTONS) as HTMLElement | null;
    if (!paypalButton) return;

    const elementsInfo = getElementsInfo();
    const { buttonMarginBottom, termsElHeight } = elementsInfo;
    paypalButton.style.bottom = `${buttonMarginBottom + termsElHeight}px`;
  };

  let observer: MutationObserver | null = null;

  const initObserver = (): void => {
    observer = new MutationObserver((mutationsList) => {
      const hasAddedNodes = mutationsList.some((mutation) => mutation.addedNodes.length);
      if (!hasAddedNodes) return;

      const paypalButtonExists = document.querySelector(SELECTORS.PAYPAL_BUTTONS);
      if (paypalButtonExists && observer) {
        observer.disconnect();
        updatePayPalButtonStyles();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  };

  const debouncedUpdateStyles = debounce(updatePayPalButtonStyles, CONFIG.RESIZE_DEBOUNCE_DELAY);

  onMounted(() => {
    initObserver();
    window.addEventListener('resize', debouncedUpdateStyles);
  });

  onBeforeUnmount(() => {
    if (observer) observer.disconnect();
    window.removeEventListener('resize', debouncedUpdateStyles);
  });
};
